// Central registry of PrymeBet public legal & policy pages.
// Each entry is a content-data module (see ./content/*.js). The registry drives
// the /legal hub, the individual routes, and the GeoGate public-path allowlist.
import terms from "./content/terms";
import sweepsRules from "./content/sweeps-rules";
import privacy from "./content/privacy";
import freeEntry from "./content/free-entry";
import purchasesRefunds from "./content/purchases-refunds";
import prizeRedemptions from "./content/prize-redemptions";
import responsiblePlay from "./content/responsible-play";
import gameRules from "./content/game-rules";
import complaints from "./content/complaints";
import cookies from "./content/cookies";
import biometricNotice from "./content/biometric-notice";
import eligibleJurisdictions from "./content/eligible-jurisdictions";

// Display order within the hub.
export const POLICIES = [
  terms,
  sweepsRules,
  privacy,
  freeEntry,
  eligibleJurisdictions,
  purchasesRefunds,
  prizeRedemptions,
  responsiblePlay,
  gameRules,
  complaints,
  cookies,
  biometricNotice,
];

export const BY_SLUG = POLICIES.reduce((acc, p) => { acc[p.slug] = p; return acc; }, {});

// Public paths that must load without authentication and from restricted
// locations (consumed by the router and GeoGate).
export const PUBLIC_LEGAL_PATHS = ["/legal", ...POLICIES.map((p) => p.path)];

// Hub groupings, in display order.
export const HUB_CATEGORY_ORDER = [
  "Core agreements",
  "Eligibility",
  "Sweepstakes",
  "Payments",
  "Player protection",
  "Games",
  "Support",
  "Privacy & data",
];

export function hubGroups() {
  const groups = {};
  POLICIES.forEach((p) => {
    const cat = p.category || "Other";
    (groups[cat] = groups[cat] || []).push(p);
  });
  const ordered = [];
  HUB_CATEGORY_ORDER.forEach((cat) => { if (groups[cat]) ordered.push([cat, groups[cat]]); });
  Object.keys(groups).forEach((cat) => { if (!HUB_CATEGORY_ORDER.includes(cat)) ordered.push([cat, groups[cat]]); });
  return ordered;
}

// Policies relevant to a given product flow (registration, checkout, wallet, verification, games, account).
export function policiesForFlow(tag) {
  return POLICIES.filter((p) => (p.flowTags || []).includes(tag));
}
